import Marionette from "backbone.marionette";
import Cleave from "cleave.js";
import $ from "jquery";
import moment from "moment-timezone";
import rollbar from "lib/rollbar";

import config from "js/config";
import events from "js/events";
import template from "js/templates/review/soft-location.jst";
import { MISMATCH_TYPE } from "lib/constants";

const SoftReviewLocation = Marionette.View.extend({
    template,

    ui: {
        btn: ".btn-confirm",
        error: ".js-error",
        errors: ".help-block",
        dateError: ".js-date-error",
        moving: "[name=moving]",
        moveDate: "[name=move-date]",
        moveDateContainer: ".move-date",
    },

    events: {
        "change @ui.moving": "onMovingChange",
        "click @ui.btn": "onConfirm",
    },

    serializeData() {
        const moveDate = this.options.user.get("move_date");
        return {
            positions: this.options.positions.toJSON(),
            moving: !!moveDate,
            moveDate: moveDate || "",
        };
    },

    onRender() {
        this.ui.errors.hide();
        /* eslint-disable no-new */
        new Cleave(this.ui.moveDate, config.cleave.DATE_CONFIG);
        /* eslint-enable */

        events.trackStep("SOFT_REVIEW_LOCATION");
    },

    onConfirm(event) {
        event.preventDefault();

        this.ui.errors.hide();

        if (!this.hasSelectedOption()) {
            this.ui.error.show();
            return;
        }

        if (this.isPassing()) {
            this.trigger("soft:finish");
            return;
        }

        const moving = this.isMoving();

        if (moving && !this.checkDate()) {
            this.ui.dateError.show();
            return;
        }

        const moveDate = moving ? this.ui.moveDate.val() : null;
        this.ui.btn.loading(true);

        $.ajax({
            type: "PATCH",
            url: "/api/v1/profile/",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                move_date: moveDate,
            }),
        })
            .fail(() => {
                rollbar.warn("Failed to save move date", { move_date: moveDate });
            })
            .always(() => {
                this.ui.btn.loading(false);

                let ackData = {};

                // Only ack if they're actually moving.
                if (moving) {
                    ackData = {
                        type: MISMATCH_TYPE.LOCATION,
                        ack: this.options.positions.map((p) => p.id),
                    };
                }

                this.trigger("soft:finish", ackData);
            });
    },

    hasSelectedOption() {
        return this.ui.moving.filter(":checked").length > 0;
    },

    isMoving() {
        return this.ui.moving.filter(":checked").val() === "yes";
    },

    isPassing() {
        return this.ui.moving.filter(":checked").val() === "pass";
    },

    checkDate() {
        const date = moment.utc(this.ui.moveDate.val());
        return date.isValid() && date.isAfter(moment.utc());
    },

    onMovingChange() {
        this.ui.moveDateContainer.toggle(this.isMoving());
    },
});

export default SoftReviewLocation;
